import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58d908a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-subtitle-1 font-weight-bold mb-4" }

import { ref, watch, onMounted } from "vue";
import {
  EquipoDTO,
  TorneoEquipoGestionInfoDTO,
} from "@/interfaces/Inscripcion";
import ModalSuccess from "@/components/Commons/ModalSuccess.vue";
import ModalError from "@/components/Commons/ModalError.vue";
import { generarRondaTorneoEquipos } from "@/services/TorneosService";
import {
  EmparejamientoEquiposDTO,
  GenerarRondaEquiposRequestDTO,
} from "@/interfaces/Torneo";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalParametrosPrimeraRondaEquipo',
  props: {
    isVisible: { type: Boolean },
    torneo: {}
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const internalIsVisible = ref(props.isVisible);

watch(
  () => props.isVisible,
  (newValue) => {
    internalIsVisible.value = newValue;
    if (newValue) initEmparejamientos();
  }
);

const numeroRonda = ref<number>(1);
const isGenerating = ref<boolean>(false);
const showErrorModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);
const configuracionManual = ref<boolean>(false);
const necesitaBye = ref<boolean>(false);
const showByeConfirmDialog = ref(false);

const numeroMesas = ref<number>(0);

const equiposDisponibles = ref<EquipoDTO[]>([]);
const emparejamientos = ref<(EquipoDTO | null)[][]>([]);

const snackBarShow = ref<boolean>(false);
const snackBarMessage = ref<string>("");
const snackBarTimeOut = ref<number>(3000);
const snackbarColor = ref<string>("error"); // puede ser 'error', 'success', 'info', etc.

const closeModal = () => {
  internalIsVisible.value = false;
  emit("close");
};

function initEmparejamientos() {
  if (!props.torneo) return;
  equiposDisponibles.value = [...props.torneo.equipos];

  numeroMesas.value = Math.ceil(equiposDisponibles.value.length / 2);
  necesitaBye.value = equiposDisponibles.value.length % 2 != 0;

  // Inicializar emparejamientos con null
  emparejamientos.value = Array(numeroMesas.value)
    .fill(null)
    .map(() => [null, null]);
}

function equiposDisponiblesParaSlot(mesaIndex: number, slotIndex: number) {
  const seleccionados = new Set<number>();

  emparejamientos.value.forEach((mesa, mIndex) => {
    mesa.forEach((equipo, sIndex) => {
      if (equipo !== null && !(mIndex === mesaIndex && sIndex === slotIndex)) {
        seleccionados.add(equipo.idEquipo);
      }
    });
  });

  return equiposDisponibles.value.filter(
    (equipo) => !seleccionados.has(equipo.idEquipo)
  );
}

const handlerGenerarRonda = () => {
  if (configuracionManual.value) {
    if (emparejamientos.value.length === 0) {
      snackBarMessage.value = "Añade al menos un emparejamiento";
      snackbarColor.value = "error";
      snackBarShow.value = true;
      return;
    }
    const allPairsValid = emparejamientos.value.every(
      (pair) => pair[0] !== null && pair[1] !== null
    );
    if (!allPairsValid) {
      if (necesitaBye.value) {
        showByeConfirmDialog.value = true;
        return;
      } else {
        snackBarMessage.value =
          "Completa todos los emparejamientos antes de generar la ronda";
        snackbarColor.value = "error";
        snackBarShow.value = true;
        return;
      }
    }
  }

  if (necesitaBye.value) {
    showByeConfirmDialog.value = true;
    return;
  }

  generaRonda();
};

const generaRonda = async () => {
  if (props.torneo?.torneo.idTorneo) {
    isGenerating.value = true;

    let emparejamientosDTO: EmparejamientoEquiposDTO[] = [];

    if (configuracionManual.value && emparejamientos.value.length > 0) {
      emparejamientosDTO = emparejamientos.value.map((par) => {
        return {
          equipo1: par[0] as EquipoDTO,
          equipo2: par[1] as EquipoDTO,
        };
      });
    }
    const request: GenerarRondaEquiposRequestDTO = {
      idTorneo: props.torneo?.torneo.idTorneo,
      idRonda: numeroRonda.value,
      isTorneoNarsil: false,
      necesitaBye: necesitaBye.value,
      emparejamientosEquipos: emparejamientosDTO,
    };
    try {
      await generarRondaTorneoEquipos(request);
      showSuccessModal.value = true;
      emit("confirm");
      closeModal();
    } catch (error) {
      console.error(error);
      showErrorModal.value = true;
    } finally {
      isGenerating.value = false;
    }
  }
};

onMounted(() => {
  if (internalIsVisible.value) initEmparejamientos();
  necesitaBye.value = equiposDisponibles.value.length % 2 != 0;

  if (necesitaBye.value)
    equiposDisponibles.value.push({
      idEquipo: 0,
      idCapitan: 0,
      inscripciones: [],
      nombreEquipo: "Equipo BYE",
    });
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_spacer = _resolveComponent("v-spacer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: internalIsVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((internalIsVisible).value = $event)),
      "max-width": "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Configurar Ronda " + _toDisplayString(numeroRonda.value), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider, { class: "my-2" }),
            _createVNode(_component_v_card_subtitle, { class: "text-subtitle-1 font-weight-medium" }, {
              default: _withCtx(() => [
                _createTextVNode(" Opciones de configuración ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_switch, {
                              modelValue: configuracionManual.value,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((configuracionManual).value = $event)),
                              color: "primary",
                              inset: "",
                              label: "¿Configurar la ronda manualmente?",
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (configuracionManual.value)
                      ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numeroMesas.value, (mesa, mesaIndex) => {
                              return (_openBlock(), _createBlock(_component_v_col, {
                                key: mesaIndex,
                                cols: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_sheet, {
                                    class: "pa-4 mb-4 rounded-lg",
                                    elevation: "1",
                                    style: {"border":"1px solid #e0e0e0"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h3", _hoisted_1, " Mesa " + _toDisplayString(mesaIndex + 1), 1),
                                      _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            md: "6"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_select, {
                                                label: "Equipo 1",
                                                items: equiposDisponiblesParaSlot(mesaIndex, 0),
                                                modelValue: emparejamientos.value[mesaIndex][0],
                                                "onUpdate:modelValue": ($event: any) => ((emparejamientos.value[mesaIndex][0]) = $event),
                                                "item-title": "nombreEquipo",
                                                "item-value": "idEquipo",
                                                "return-object": "",
                                                variant: "outlined",
                                                clearable: "",
                                                dense: ""
                                              }, null, 8, ["items", "modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            md: "6"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_select, {
                                                label: "Equipo 2",
                                                items: equiposDisponiblesParaSlot(mesaIndex, 1),
                                                modelValue: emparejamientos.value[mesaIndex][1],
                                                "onUpdate:modelValue": ($event: any) => ((emparejamientos.value[mesaIndex][1]) = $event),
                                                "item-title": "nombreEquipo",
                                                "item-value": "idEquipo",
                                                "return-object": "",
                                                variant: "outlined",
                                                clearable: "",
                                                dense: ""
                                              }, null, 8, ["items", "modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  justify: "center",
                  class: "my-4 gap-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      disabled: isGenerating.value,
                      onClick: handlerGenerarRonda,
                      color: "primary",
                      variant: "tonal"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Generar ronda ")
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_v_btn, {
                      variant: "tonal",
                      color: "secondary",
                      onClick: closeModal,
                      large: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Cancelar ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: isGenerating.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isGenerating).value = $event)),
      "hide-overlay": "",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "progress-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "70"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Ronda generada correctamente.",
      "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se ha podido generarla ronda. Inténtalo de nuevo y si el error persiste contacta con el administrador.",
      "onUpdate:isVisible": _cache[4] || (_cache[4] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(_component_v_snackbar, {
      modelValue: snackBarShow.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((snackBarShow).value = $event)),
      color: snackbarColor.value,
      timeout: snackBarTimeOut.value,
      location: "top",
      vertical: "",
      rounded: "",
      elevation: "6"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          text: "",
          icon: "",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (snackBarShow.value = false)),
          "aria-label": "Close"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => [
                _createTextVNode("mdi-close")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(snackBarMessage.value) + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "color", "timeout"]),
    _createVNode(_component_v_dialog, {
      modelValue: showByeConfirmDialog.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showByeConfirmDialog).value = $event)),
      "max-width": "400",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-h6" }, {
              default: _withCtx(() => [
                _createTextVNode("Confirmar Bye")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" Los equipos son impares. ¿Quieres proceder con un bye? ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  text: "",
                  color: "primary",
                  variant: "tonal",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (showByeConfirmDialog.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cancelar ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "tonal",
                  onClick: _cache[8] || (_cache[8] = 
            () => {
              showByeConfirmDialog.value = false;
              generaRonda();
            }
          )
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Confirmar ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})